import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import { blue, orange } from '@material-ui/core/colors';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import IconButton from '@mui/material/IconButton';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import { PageLoading } from "src/components";
import { VendorRegisService } from "src/services";
import { userStorage } from "src/common/Storage";
import LabelStatusButton from './UI/LabelStatusButton'
import {
  Autocomplete,
  createFilterOptions
} from "@mui/material";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: '3%',
    marginRight: '3%',
    marginTop: '2%',
  },
  head: {
    color: '#0009b7',
    fontWeight: 'regular'
  },
  cardBack: {
    backgroundColor: blue[500]
  },
  Roundborder: {
    border: '0.5px outset #cfcfcf',
    borderRadius: '5px',
    marginTop: '1%',
    marginBottom: '2%',
    backgroundColor: 'white',
  },
  textarea: {
    resize: "both"
  },
  tableContainer: {
    overflowY: "auto"
  },
  table: { //...
    height: "100%",
    overflowY: "scroll"
  },
  ImageIcon: {
    // marginTop: theme.spacing(3),
    width: 25,
    // [theme.breakpoints.down("md")]: {
    //   width: 30,
    // },
  },

}));

const ColorIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText(orange[500]),
  backgroundColor: orange[500],
  '&:hover': {
    backgroundColor: orange[700],
  },
}));






function VendorRegisScreen() {
  const classes = useStyles();
  const history = useHistory();
  const [onLoading, setOnLoading] = useState(false);
  const userInfo = userStorage.getUser();
  const userProfile = userInfo?.userProfile || {};
  const { t } = useTranslation();

  const columns = [
    { id: 'vendorRegisID', display: 'none' },
    { id: 'mainVersionID', display: 'none' },
    { id: 'subVersionID', display: 'none' },
    { id: 'id', label: '', minWidth: 50 },
    { id: 'versionName', label: 'Version', minWidth: 100, align: 'left' },
    { id: 'esgFormName', label: <>{t("VendorRegis.evaluateName2")}</>, minWidth: 170, align: 'left' },
    { id: 'status', label: <>{t("VendorRegis.status")}</>, minWidth: 100, align: 'center', },
    { id: 'fullScore', label: <>{t("VendorRegis.fullScore")}</>, minWidth: 100, align: 'center', format: (value) => value.toFixed(2), },
    { id: 'score', label: <>{t("VendorRegis.score")}</>, minWidth: 100, align: 'center', format: (value) => value.toFixed(2), },
    { id: 'resultCodeDesc', label: <>{t("VendorRegis.assScore")}</>, minWidth: 100, align: 'center', },
    { id: 'updateDate', label: <>{t("VendorRegis.transDate")}</>, minWidth: 100, align: 'center', format: (value) => value.toLocaleDateString('en-US'), },
  ];

  const columnsTab2 = [
    { id: 'vendorRegisID', display: 'none' },
    { id: 'mainVersionID', display: 'none' },
    { id: 'subVersionID', display: 'none' },
    { id: 'id', label: '', minWidth: 50 },
    { id: 'versionName', label: 'Version', minWidth: 100, align: 'left' },
    { id: 'esgFormName', label: <>{t("VendorRegis.evaluateName2")}</>, minWidth: 170, align: 'left' },
    { id: 'status', label: <>{t("VendorRegis.status")}</>, minWidth: 100, align: 'center', },
    { id: 'fullScore', label: <>{t("VendorRegis.fullScore")}</>, minWidth: 100, align: 'center', format: (value) => value.toFixed(2), },
    { id: 'score', label: <>{t("VendorRegis.score")}</>, minWidth: 100, align: 'center', format: (value) => value.toFixed(2), },
    { id: 'resultCodeDesc', label: <>{t("VendorRegis.assScore")}</>, minWidth: 100, align: 'center', },
    { id: 'updateDate', label: <>{t("VendorRegis.transDate")}</>, minWidth: 100, align: 'center', format: (value) => value.toLocaleDateString('en-US'), },
  ];
  const inputGrid1 = {
    lang: "th",
    version: "",
    evaluationName: "",
    status: "",
    vatRegistrationNo: userProfile.vatRegistrationNo
  };

  const inputGrid2 = {
    lang: "th",
    version: "",
    // evaluationName: "",
    status: "",
    evaluate: "",
    vatRegistrationNo: userProfile.vatRegistrationNo
  };

  const [currentForm, setCurrentForm] = useState({});
  const gotoAssessment = () => {
    history.push({
      pathname: "/VendorSelfAssessment",
      state: {
        vendor: 0,
        main: currentForm.mainVersionID,
        sub: currentForm.subVersionID,
        type: "SelfAssessment_V",
      },
    });
  }

  const gotoAssessmentEdit = (data) => {
    history.push({
      pathname: "/VendorSelfAssessment",
      state: {
        vendor: data.vendorRegisID,
        main: data.mainVersionID,
        sub: data.subVersionID,
        type: "SelfAssessment_V",
      },
    });
  }

  const [evalText1, SetevalText1] = useState("");
  const [evalText2, SetevalText2] = useState("");

  const [rows, setrows] = useState([]);
  const [rowsTab2, setrowsTab2] = useState([]);

  const [tabpage, tabpagesetValue] = useState('1');

  const [ddlVersion, setddlVersion] = useState([]);
  const [ddlVersionTab2, setddlVersionTab2] = useState([]);

  const [ddlStatus, setddlStatus] = useState([]);
  const [ddlStatusTab2, setddlStatusTab2] = useState([]);
  const [ddlEvaluate, setddlEvaluate] = useState([]);
  const [classDivnew, setClassDivnew] = useState();


  const [Version, setVersion] = useState('');
  const handleChangeVersion = (event) => {
    setVersion(event.target.textContent);
  };

  const [Version2, setVersion2] = useState('');
  const handleChangeVersion2 = (event) => {
    setVersion2(event.target.textContent);
  };

  const [Status, setStatus] = useState('');
  const handleChangeStatus = (event) => {
    var tmp = ddlStatus.filter(x => x.label === event.target.textContent)
    setStatus(tmp.length > 0 ? tmp[0].value : '');
  };

  const [StatusTab2, setStatusTab2] = useState('');
  const handleChangeStatusTab2 = (event) => {
    var tmp = ddlStatusTab2.filter(x => x.label === event.target.textContent)
    setStatusTab2(tmp.length > 0 ? tmp[0].value : '');
  };

  const [Evaluate, setEvaluate] = useState('');
  const handleChangeEvaluate = (event) => {
    var tmp = ddlEvaluate.filter(x => x.label === event.target.textContent)
    setEvaluate(tmp.length > 0 ? tmp[0].value : '');
  };


  const tabhandleChange = (event, tabnewValue) => {
    tabpagesetValue(tabnewValue);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const editIcon = (data) => (
    <div>
      <Tooltip placement="right-start" arrow title="แก้ไขข้อมูล">
        <IconButton onClick={() => gotoAssessmentEdit(data)}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </div>
  );

  const assignmentIcon = (data) => (
    <div>
      <Tooltip placement="right-start" arrow title="ดูข้อมูลแบบประเมิน">
        <IconButton onClick={() => gotoAssessmentEdit(data)}>
          <AssignmentIcon />
        </IconButton>
      </Tooltip>
    </div>
  );

  const resultCodeStyle = (data) => (
    <LabelStatusButton code={data.resultCode} desc={data.resultCodeDesc} />
  );

  const statusStyle = (data) => (
    data.code === "A" ? <Tooltip placement="top" arrow title={data.tooltipDesc !== null ? data.tooltipDesc : ''}><Box sx={{ color: data.textColor, fontWeight: 'bold', cursor: 'pointer' }}>{data.name}</Box></Tooltip>
      : data.code === "D" ? <Tooltip placement="top" arrow title={data.tooltipDesc !== null ? data.tooltipDesc : ''}><Box sx={{ color: data.textColor, fontWeight: 'bold', cursor: 'pointer' }}>{data.name}</Box></Tooltip>
        : data.code === "I" ? <Tooltip placement="top" arrow title={data.tooltipDesc !== null ? data.tooltipDesc : ''}><Box sx={{ color: data.textColor, fontWeight: 'bold', cursor: 'pointer' }}>{data.name}</Box></Tooltip>
          : data.code === "R" ? <Tooltip placement="top" arrow title={data.tooltipDesc !== null ? data.tooltipDesc : ''}><Box sx={{ color: data.textColor, fontWeight: 'bold', cursor: 'pointer' }}>{data.name}</Box></Tooltip>
            : ""
  );

  const SearchGrid1 = () => {
    setOnLoading(true);
    inputGrid1.lang = 'th';
    inputGrid1.version = Version === '--- ทั้งหมด ---' ? '' : Version;
    inputGrid1.evaluationName = evalText1 === '--- ทั้งหมด ---' ? '' : evalText1;
    inputGrid1.status = Status === '--- ทั้งหมด ---' ? '' : Status;
    inputGrid1.vatRegistrationNo = userProfile.vatRegistrationNo

    VendorRegisService.GridESGData(inputGrid1).then(
      (resp) => {
        setrows(resp);
        setOnLoading(false);
      }
    )
  }

  const SearchGrid2 = () => {
    setOnLoading(true);
    inputGrid2.lang = 'th';
    inputGrid2.version = Version2 === '--- ทั้งหมด ---' ? '' : Version2;;
    // inputGrid2.evaluationName = evalText2 === '--- ทั้งหมด ---' ? '' : evalText2;;
    inputGrid2.status = StatusTab2 === '--- ทั้งหมด ---' ? '' : StatusTab2;
    inputGrid2.evaluate = Evaluate === '--- ทั้งหมด ---' ? '' : Evaluate;;
    inputGrid2.vatRegistrationNo = userProfile.vatRegistrationNo

    VendorRegisService.GridESGDataHistory(inputGrid2).then(
      (resp) => {
        setrowsTab2(resp);
        setOnLoading(false);
      }
    )
  }

  const AssignmentIconTab2 = (data) => (
    <div>
      <Tooltip placement="right-start" arrow title="ดูข้อมูลแบบประเมิน">
        <IconButton onClick={() => gotoAssessmentEdit(data)}>
          <AssignmentIcon />
        </IconButton>
      </Tooltip>
    </div>
  );

  useEffect(() => {
    setOnLoading(true);
    VendorRegisService.getCurrentForm().then(
      (resp) => {
        setCurrentForm(resp);
      }
    );

    VendorRegisService.ddlVersion().then(
      (resp) => {
        var tmp = [{ value: '--- ทั้งหมด ---', label: '--- ทั้งหมด ---' }]
        for (var i = 0; i < resp.length; i++) {
          tmp.push(resp[i])
        }
        setddlVersion(tmp);
      }
    );

    VendorRegisService.ddlVersionTab2().then(
      (resp) => {
        var tmp = [{ value: '--- ทั้งหมด ---', label: '--- ทั้งหมด ---' }]
        for (var i = 0; i < resp.length; i++) {
          tmp.push(resp[i])
        }
        setddlVersionTab2(tmp);
      }
    );

    VendorRegisService.ddlStatus().then(
      (resp) => {
        var tmp = [{ value: '--- ทั้งหมด ---', label: '--- ทั้งหมด ---' }]
        for (var i = 0; i < resp.length; i++) {
          tmp.push(resp[i])
        }
        setddlStatus(tmp);
      }
    );

    VendorRegisService.ddlStatusTab2().then(
      (resp) => {
        var tmp = [{ value: '--- ทั้งหมด ---', label: '--- ทั้งหมด ---' }]
        for (var i = 0; i < resp.length; i++) {
          tmp.push(resp[i])
        }
        setddlStatusTab2(tmp);
      }
    );

    VendorRegisService.ddlEvaluate().then(
      (resp) => {
        var tmp = [{ value: '--- ทั้งหมด ---', label: '--- ทั้งหมด ---' }]
        for (var i = 0; i < resp.length; i++) {
          tmp.push(resp[i])
        }
        setddlEvaluate(tmp);
      }
    );

    VendorRegisService.GridESGData(inputGrid1).then(
      (resp) => {
        setrows(resp);
      }
    );

    VendorRegisService.GridESGDataHistory(inputGrid2).then(
      (resp) => {
        setrowsTab2(resp);
        setOnLoading(false);
      }
    );

    VendorRegisService.getActiveBtnNew(userProfile.vatRegistrationNo).then((res) => {
      if (res.data === true) {
        setClassDivnew("play-btn");
      } else {
        setClassDivnew(" ");
      }
    });

  }, []);

  return <div className={classes.root}>
    <PageLoading open={onLoading} />
    <div className={classes.head}>
      <Grid columns={16} container direction="row" justifyContent="space-between" alignContent="center" alignItems="center">
        <Grid item xs={12} >
          <div>
            <h1>{t("VendorRegis.headerLabel")}</h1>
          </div>
        </Grid>
        <Grid item xs={4} style={{ flexGrow: "1" }}>
          <div style={{ float: "right",marginRight:"20px" }} className={classDivnew}>
            <Stack direction="row" spacing={4} >
              <Button sx={{ color: 'white', padding: '5px', boxShadow: 3, margin: '5px' }} variant="outlined"
                style={{ flexGrow: "1", backgroundColor: '#0FBEF5', border: '2px solid #0FBEF5', borderRadius: '5px', borderColor: '#0FBEF5' }}
                onClick={() => gotoAssessment()}>
                {(classDivnew && classDivnew.length > 3) ?
                  <NotificationsActiveIcon style={{ zIndex: '1000', position: 'absolute', left: '0px', top: '0px', color: 'red' }} />
                  : <></>}
                <Stack direction="row" spacing={2}>
                  <Stack justifyContent="center">
                    <img
                      sx={{ width: 25 }}
                      alt="Logo"
                      src="/images/doc_create_esg.png"
                    />
                  </Stack>
                  <Stack direction="column">
                    <Stack>{currentForm.esgFormNameTH}</Stack>
                    <Stack>{currentForm.versionName}</Stack>
                    <Stack sx={{ marginLeft: '10px', marginTop: '4px', boxShadow: 3, backgroundColor: '#053BFB', border: '5px solid #053BFB', borderRadius: '5px 5px', fontWeight: 'bold' }}>

                    {t("VendorRegis.btnMakeAss")}</Stack>
                  </Stack>
                </Stack>
              </Button>
            </Stack>
          </div>
        </Grid>
      </Grid>
    </div>

    <br />
    <Box sx={{ width: '100%' }}>
      <TabContext value={tabpage}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
          <TabList onChange={tabhandleChange}>
            <Tab label={t("VendorRegis.tab1")} value="1"></Tab>
            <Tab label={t("VendorRegis.tab2")} value="2"></Tab>
          </TabList>
        </Box>

        <TabPanel value="1" className={classes.Roundborder}>
          <Grid container style={{ fontWeight: 'bold' }} direction="row" justifyContent="left">
          {t("VendorRegis.pendingAssList")}
          </Grid>
          <br />
          <Grid container rowSpacing={2} spacing={1} columns={16} direction="row" alignContent="center" justifyContent="left">
            <Grid item xs={3}>
              <FormControl sx={{ width: '100%' }}>
                <Autocomplete
                  id="idVersion"
                  size="small"
                  options={ddlVersion}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={ddlVersion.filter(x => x.label === Version).length > 0
                    ? ddlVersion.filter(x => x.label === Version)[0]
                    : ''}
                  renderInput={(params) => <TextField size="small" {...params} label="Version" />}
                  onChange={(event) => { handleChangeVersion(event) }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={9}>
              <TextField size="small" onChange={(e) => (SetevalText1(e.target.value))} style={{ backgroundColor: 'white' }} fullWidth id="outlined-search" label={t("VendorRegis.evaluateName")} type="search" inputProps={{ className: classes.textarea }} />
            </Grid>
            <Grid item xs={3}>
              <FormControl sx={{ width: '100%' }}>
                <Autocomplete
                  id="idStatus"
                  size="small"
                  options={ddlStatus}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={ddlStatus.filter(x => x.value === Status).length > 0
                    ? ddlStatus.filter(x => x.value === Status)[0]
                    : ''}
                  renderInput={(params) => <TextField size="small" {...params} label={t("VendorRegis.status")} />}
                  onChange={(event) => { handleChangeStatus(event) }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={1}>
              <ColorIconButton sx={{ color: '#ffa489', backgroundColor: "#FFA489" }} size="small" onClick={() => SearchGrid1()} >
                <SearchRoundedIcon sx={{ color: 'white' }} />
              </ColorIconButton>
            </Grid>
            <Grid item xs={16}>
              <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer className={classes.tableContainer}>
                  <Table stickyHeader aria-label="sticky table" className={classes.table}>
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth, fontSize: '1rem', fontWeight: 'bold', display: column.display, backgroundColor: "#8ae3ff", color: "#00358a" }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.length > 0 ?
                        rows
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row, i) => {
                            return <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                              {columns.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell key={column.id} align={column.align} style={{ display: column.display }}>
                                    {column.format && typeof value === 'number'
                                      ? (column.id === 'id') ? assignmentIcon(value) : column.format(value)
                                      : (column.id === 'id') ? (row.status.code === "D") ? editIcon(row) : assignmentIcon(row)
                                        : (column.id === 'resultCodeDesc') ? resultCodeStyle(row)
                                          : (column.id === 'status') ? statusStyle(value)
                                            : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          })
                        :
                        <TableRow >
                          <TableCell colSpan={7}>
                            <Grid container style={{ fontWeight: 'bold' }} direction="row" justifyContent="center">
                              {t("VendorRegis.dataNotFound")}
                            </Grid>
                          </TableCell>
                        </TableRow>
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value="2" className={classes.Roundborder}>
          <Grid container style={{ fontWeight: 'bold' }} direction="row" justifyContent="left">
          {t("VendorRegis.hisAssList")}
          </Grid>
          <br />
          <Grid container rowSpacing={2} spacing={1} columns={16} direction="row" alignContent="center" justifyContent="left">
            <Grid item xs={5}>
              <FormControl sx={{ width: '100%' }}>
                <Autocomplete
                  id="idVersion"
                  size="small"
                  options={ddlVersionTab2}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={ddlVersionTab2.filter(x => x.label === Version2).length > 0
                    ? ddlVersionTab2.filter(x => x.label === Version2)[0]
                    : ''}
                  renderInput={(params) => <TextField size="small" {...params} label="Version" />}
                  onChange={(event) => { handleChangeVersion2(event) }}
                />
              </FormControl>
            </Grid>
            {/* <Grid item xs={9}>
              <TextField size="small" onChange={(e) => (SetevalText2(e.target.value))} style={{ backgroundColor: 'white' }} fullWidth id="outlined-search" label="ชื่อแบบประเมิน" type="search" inputProps={{ className: classes.textarea }} />
            </Grid> */}
            <Grid item xs={5}>
              <FormControl sx={{ width: '100%' }}>
                <Autocomplete
                  id="idStatusTab2"
                  size="small"
                  options={ddlStatusTab2}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={ddlStatusTab2.filter(x => x.value === StatusTab2).length > 0
                    ? ddlStatusTab2.filter(x => x.value === StatusTab2)[0]
                    : ''}
                  renderInput={(params) => <TextField size="small" {...params} label={t("VendorRegis.status")} />}
                  onChange={(event) => { handleChangeStatusTab2(event) }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={5}>
              <FormControl sx={{ width: '100%' }}>
                <Autocomplete
                  id="idEvaluate"
                  size="small"
                  options={ddlEvaluate}
                  filterOptions={createFilterOptions({
                    limit: 20,
                  })}
                  value={ddlEvaluate.filter(x => x.value === Evaluate).length > 0
                    ? ddlEvaluate.filter(x => x.value === Evaluate)[0]
                    : ''}
                  renderInput={(params) => <TextField size="small" {...params} label={t("VendorRegis.assScore")} />}
                  onChange={(event) => { handleChangeEvaluate(event) }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={1}>
              <ColorIconButton sx={{ color: '#ffa489', backgroundColor: "#FFA489" }} size="small" onClick={() => SearchGrid2()} >
                <SearchRoundedIcon sx={{ color: 'white' }} />
              </ColorIconButton>
            </Grid>
            <Grid item xs={16}>
              <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer className={classes.tableContainer}>
                  <Table stickyHeader aria-label="sticky table" className={classes.table}>
                    <TableHead>
                      <TableRow>
                        {columnsTab2.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth, fontSize: '1rem', fontWeight: 'bold', display: column.display, backgroundColor: "#8ae3ff", color: "#00358a" }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowsTab2.length > 0 ?
                        rowsTab2
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row, i) => {
                            return <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                              {columnsTab2.map((column) => {
                                const value = row[column.id];
                                return (
                                  <TableCell key={column.id} align={column.align} style={{ display: column.display }}>
                                    {column.format && typeof value === 'number'
                                      ? (column.id === 'id') ? AssignmentIconTab2(value) : column.format(value)
                                      : (column.id === 'id') ? AssignmentIconTab2(row)
                                        : (column.id === 'resultCodeDesc') ? resultCodeStyle(row)
                                          : (column.id === 'status') ? statusStyle(value)
                                            : value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          })
                        :
                        <TableRow >
                          <TableCell colSpan={7}>
                            <Grid container style={{ fontWeight: 'bold' }} direction="row" justifyContent="center">
                            {t("VendorRegis.dataNotFound")}
                            </Grid>
                          </TableCell>
                        </TableRow>
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={rowsTab2.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>

      </TabContext>
    </Box>
  </div>

}

export default VendorRegisScreen;
